import React from 'react';
import logo from './uwublk.webp';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          UwU Black Market coming soon...
        </p>
        <a
          className="App-link"
          href="https://uwu.direct"
          target="_blank"
          rel="noopener noreferrer"
        >
          UwU.Direct
        </a>
      </header>
    </div>
  );
}

export default App;
